import React from "react";
import { Link, Text } from "@chakra-ui/react";

import { DateDisplay } from "@components";
import { useBuildData } from "@hooks";

/**
 * Helper component to format build information provided by useBuildData into
 * a simple text component.
 */
export function BuildDescription() {
  const { hash, branch, buildTime } = useBuildData();
  if (!hash && !branch && !buildTime) return null;

  return (
    <Text>
      This app was built
      <BuildTime buildTime={buildTime} />
      <GitDescription hash={hash} branch={branch} />.
    </Text>
  );
}

function BuildTime({ buildTime }: { buildTime?: Date }) {
  if (!buildTime) return null;
  return (
    <>
      {" "}
      <DateDisplay date={buildTime} />
    </>
  );
}

function GitDescription({ hash, branch }: { hash?: string; branch?: string }) {
  if (!hash && !branch) {
    return null;
  }
  return (
    <>
      {" (from source "}
      {branch ? (
        <Link
          href={`https://github.com/brown-ccv/collider-parts-db/tree/${branch}`}
        >
          {branch}
        </Link>
      ) : undefined}
      {branch && hash ? "@" : undefined}
      {hash ? (
        <Link
          href={`https://github.com/brown-ccv/collider-parts-db/commit/${hash}`}
        >
          {hash.slice(0, 6)}
        </Link>
      ) : undefined}
      {")"}
    </>
  );
}
